import { render, staticRenderFns } from "./LanguageSelectDropdown.vue?vue&type=template&id=24efce12&scoped=true"
import script from "./LanguageSelectDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageSelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelectDropdown.vue?vue&type=style&index=0&id=24efce12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24efce12",
  null
  
)

export default component.exports